export default __webpack_public_path__ + "08d0c70a708cd25acecb7a8b0cb0eb23.png";